
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("@embroider/macros/es-compat2", function(){ return i("@embroider/macros/es-compat2");});
d("@embroider/macros/runtime", function(){ return i("@embroider/macros/runtime");});
import "@embroider/macros/-embroider-implicit-modules.js";
